import { requestPolicy } from '@gravllift/halo-helpers';

export const waypointXboxRequestPolicy = requestPolicy;
